import React, { useState } from 'react';
import Logo from '../utils/logo';
import SearchBar from '../utils/search';
import Likes from '../utils/likes';
import { constantStyles } from '../constants/constantStyles';
import { useMediaQuery } from 'react-responsive';

const centerLogo = true
const onSearch = (searchValue) => {
    const encodedSearchValue = encodeURIComponent(searchValue);
    window.location.href = '/search?query=' + encodedSearchValue;
}
const HeaderBody = () => {

    const [isFocused, setIsFocused] = useState(false);

    const isMobile = useMediaQuery({ maxWidth: constantStyles.mobileWidth });

    const padding = isMobile ? '16px 0' : '24px 0';
    return (
        <div style={{...styles.headerContainer, ...{padding}}}>
            <div
                style={{
                    ...styles.logo,
                    ...(isFocused ? styles.hiddenToLeft : {}),
                }}
            >
                <Logo />
            </div>
            <div
                style={{
                    ...styles.searchBarContainer,
                    ...(isFocused ? styles.searchBarExpanded : {}),
                }}
            >
                <SearchBar
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    styleOverride={{}}
                    onSearch={onSearch}
                />
            </div>
            <div
                style={{
                    ...styles.likes,
                    ...(isFocused ? styles.hiddenToRight : {}),
                }}
            >
                <Likes />
            </div>
        </div>
    );
};
/* <SearchBar styleOverride={{width: "50%"}}/> */
/* remove likes container when switching to old header style */
export default HeaderBody;

const transition = 'all 0.4s ease';

const styles = {
    headerContainer: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        position: 'relative',
        margin: constantStyles.outermostMargin,
    },
    logo: {
        flexShrink: 0,
        transition,
    },
    likes: {
        flexShrink: 0,
        transition,
    },
    searchBarContainer: {
        flexGrow: 1,
        transition,
        margin: '0 16px',
    },
    searchBarExpanded: {
        margin: 0,
    },
    hiddenToLeft: {
        transform: 'translateX(-100%)',
        opacity: 0,
        width: 0,
    },
    hiddenToRight: {
        transform: 'translateX(100%)',
        opacity: 0,
        width: 0,
    },



    headerContainerCenteredLogo: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        padding: '24px 0',
        margin: constantStyles.outermostMargin,
    },
    likesContainer: {
        position: 'absolute',
        float: 'right',
        right: '24px',
    },
};